import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=2c4f5439&scoped=true"
import script from "./Step.vue?vue&type=script&lang=ts"
export * from "./Step.vue?vue&type=script&lang=ts"
import style0 from "./Step.vue?vue&type=style&index=0&id=2c4f5439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f5439",
  null
  
)

export default component.exports